import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-icon-input-wrapper',
  templateUrl: './icon-input-wrapper.component.html',
  styleUrl: './icon-input-wrapper.component.scss'
})
export class IconInputWrapperComponent extends FieldWrapper{

}
